import { Grid, makeStyles, Typography } from "@material-ui/core";
import { AiOutlineClose, AiOutlineInfoCircle } from "react-icons/ai";
import { COLORS } from "../../theme/colors";
import { styles } from "../../theme/styles";
import { Icon } from "../base";
import checkImg from "../../assets/images/icons/successMessage.png";

const useStyles = makeStyles((theme) => ({
  container: {
    top: (props) => props.topOffset,
    left: 0,
    right: 0,
    position: "absolute",
    backgroundColor: "#FCF3D9",
    marginLeft: "auto",
    marginRight: "auto",
    width: "fit-content",
    zIndex: 1300,
    borderRadius: 8,
    boxShadow: styles.boxShadows.darks[4],
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
  },
  successContainer: {
    top: (props) => props.topOffset,
    left: 0,
    right: 0,
    position: "absolute",
    backgroundColor: COLORS.lightGreen,
    marginLeft: "auto",
    marginRight: "auto",
    width: "fit-content",
    zIndex: 10000,
    borderRadius: 8,
    boxShadow: styles.boxShadows.customDarks[4],
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
  },
  icon: {
    color: COLORS.orange,
    marginRight: theme.spacing(1),
  },
  closeIcon: {
    marginLeft: theme.spacing(2.5),
    cursor: "pointer",
  },
}));

export const MessageAlert = ({ topOffset = 30, text, textStyle, allowClose, onClose, success }) => {
  const classes = useStyles({ topOffset });

  return (
    <Grid
      className={success ? classes.successContainer : classes.container}
      container
      alignItems="center"
      justifyContent="center"
    >
      {success ? (
        <Icon src={checkImg} width={50} height={50} />
      ) : (
        <AiOutlineInfoCircle className={classes.icon} size={20} />
      )}
      <Typography style={{ fontSize: 18, ...textStyle }}>{text}</Typography>
      {allowClose && <AiOutlineClose className={classes.closeIcon} size={20} onClick={onClose} />}
    </Grid>
  );
};
